import { render } from "./VideoStyleOne.vue?vue&type=template&id=525869a3"
import script from "./VideoStyleOne.vue?vue&type=script&lang=js"
export * from "./VideoStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__